import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserService } from "src/app/shared/services/user.service";
import { Observable } from "rxjs";
import { TimeStatusLog } from "../models/time-status-log.model";
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})

export class TimeStatusLogsService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
        super(us);
        this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-project-key', }) };
        this.baseUrl = `${this.configService.config.projectUrl}/api/timestatuslogs`;
      }
  
      getByTimeId(id: number): Observable<TimeStatusLog[]> {
        return this.http.get<TimeStatusLog[]>(`${this.baseUrl}/getTimeStatusLogByTimeId?timeids=${id}`, this.httpOptions)
          .pipe(catchError(this.handleError<any>(`Failed to get Time Status Logs`)));
      }

      getAllStatusLogs(): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/getalltimestatuslogs`, this.httpOptions)
          .pipe(catchError(this.handleError<any>(`Failed to get all Time Status Logs`)));
      }

      getByDateAndTimeId(date: Date, id: number): Observable<TimeStatusLog[]> {
        return this.http.get<TimeStatusLog[]>(`${this.baseUrl}/getTimeStatusLogByDateAndTimeId?date=${date}&timeids=${id}`, this.httpOptions)
          .pipe(catchError(this.handleError<any>(`Failed to get Time Status Logs`)));
      }

      getAllStatuses(): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/getAllStatuses`, this.httpOptions)
          .pipe(catchError(this.handleError<any>(`Failed to get statuses`)));
      }


}

